export default "__VITE_ASSET__i2ywl_YzKp2MjtOEr7ngzA__"